module.exports = __webpack_public_path__ + "img/jf4.9b94f07a.png";